/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentResponse } from './AppointmentResponse';
import {
    AppointmentResponseFromJSON,
    AppointmentResponseFromJSONTyped,
    AppointmentResponseToJSON,
    AppointmentResponseToJSONTyped,
} from './AppointmentResponse';

/**
 * 
 * @export
 * @interface CreateClientAppointmentResponse
 */
export interface CreateClientAppointmentResponse {
    /**
     * 
     * @type {AppointmentResponse}
     * @memberof CreateClientAppointmentResponse
     */
    appointment: AppointmentResponse;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClientAppointmentResponse
     */
    notifiedBySms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateClientAppointmentResponse
     */
    notifiedByEmail: boolean;
}

/**
 * Check if a given object implements the CreateClientAppointmentResponse interface.
 */
export function instanceOfCreateClientAppointmentResponse(value: object): value is CreateClientAppointmentResponse {
    if (!('appointment' in value) || value['appointment'] === undefined) return false;
    if (!('notifiedBySms' in value) || value['notifiedBySms'] === undefined) return false;
    if (!('notifiedByEmail' in value) || value['notifiedByEmail'] === undefined) return false;
    return true;
}

export function CreateClientAppointmentResponseFromJSON(json: any): CreateClientAppointmentResponse {
    return CreateClientAppointmentResponseFromJSONTyped(json, false);
}

export function CreateClientAppointmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClientAppointmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appointment': AppointmentResponseFromJSON(json['appointment']),
        'notifiedBySms': json['notifiedBySms'],
        'notifiedByEmail': json['notifiedByEmail'],
    };
}

export function CreateClientAppointmentResponseToJSON(json: any): CreateClientAppointmentResponse {
    return CreateClientAppointmentResponseToJSONTyped(json, false);
}

export function CreateClientAppointmentResponseToJSONTyped(value?: CreateClientAppointmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointment': AppointmentResponseToJSON(value['appointment']),
        'notifiedBySms': value['notifiedBySms'],
        'notifiedByEmail': value['notifiedByEmail'],
    };
}

